import gql from "../gql";
import EarnedAwards from "../fragments/EarnedAwards";
export default gql `
  query getAllEarnedAwards(
    $first: Int
    $after: String
    $trailblazerId: TrailblazerId
  ) {
    getAllEarnedAwards(
      first: $first
      after: $after
      trailblazerId: $trailblazerId
    ) {
      ...EarnedAwards
    }
  }
  ${EarnedAwards}
`;
